document.addEventListener("DOMContentLoaded", function() {
  const loadMoreBtn = document.getElementById('load-more-btn');
  const articleList = document.getElementById('blog-articles-list');
  
  // Variables you can adjust based on your layout
  let currentlyVisible = 24; // This MUST match the Liquid `forloop.index > 24` condition
  const articlesToLoad = 12; // How many articles to reveal every time the button is clicked

  if (loadMoreBtn && articleList) {
    const allArticles = articleList.querySelectorAll('.blog-articles__article');

    loadMoreBtn.addEventListener('click', function() {
      let newlyShown = 0;

      // Loop through the articles starting from the currently visible index
      for (let i = currentlyVisible; i < allArticles.length; i++) {
        if (newlyShown < articlesToLoad) {
          allArticles[i].style.display = 'block'; // Reveal the article by removing display: none
          newlyShown++;
        }
      }

      // Update our tracker
      currentlyVisible += newlyShown;

      // If we've shown all articles, hide the Load More button
      if (currentlyVisible >= allArticles.length) {
        loadMoreBtn.style.display = 'none';
      }
    });
  }
});